import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import MuiLink from '@material-ui/core/Link';
import SkeletonBody from '@afosto/components-react/SkeletonBody';
import { shipments as shipmentsApi } from '@afosto/fulfilment/api/Shipments';

const BASE_URL = process.env.REACT_APP_BASE_APP_URL;
const FULFILMENT_APP_ORIGIN = BASE_URL.replace('{app}', 'fulfilment');

const ShipmentsFormatter = ({ shipmentIds }) => {
  const [shipments, setShipments] = useState([]);
  const [isLoadingShipments, setIsLoadingShipments] = useState(false);
  const isSameOrigin = window.location.origin === FULFILMENT_APP_ORIGIN;

  useEffect(() => {
    let isMounted = true;

    const fetchShipments = async ids => {
      setIsLoadingShipments(true);

      try {
        const promises = ids.map(id => shipmentsApi.viewShipment(id));
        const responses = await Promise.allSettled(promises).then(result =>
          result.filter(promise => promise.status === 'fulfilled'),
        );
        const formattedShipments = responses.reduce(
          (acc, response) => [...acc, response.value.data],
          [],
        );

        if (isMounted) {
          setShipments(formattedShipments);
        }
      } catch (err) {
        if (isMounted) {
          setShipments([]);
        }
      } finally {
        if (isMounted) {
          setIsLoadingShipments(false);
        }
      }
    };

    if (shipmentIds.length > 0) {
      fetchShipments(shipmentIds);
    }

    return () => {
      isMounted = false;
    };
  }, [shipmentIds]);

  if (isLoadingShipments) {
    return <SkeletonBody lines={1} />;
  }

  if (shipments.length === 0) {
    return '-';
  }

  return shipments.map((shipment, idx) => (
    <Fragment key={shipment.id}>
      {isSameOrigin ? (
        <MuiLink variant="subtitle1" component={Link} to={`/shipments/${shipment.id}`}>
          {shipment.number ?? 'Concept'}
        </MuiLink>
      ) : (
        <MuiLink variant="subtitle1" href={`${FULFILMENT_APP_ORIGIN}/shipments/${shipment.id}`}>
          {shipment.number ?? 'Concept'}
        </MuiLink>
      )}
      {shipments.length !== idx + 1 && ', '}
    </Fragment>
  ));
};

ShipmentsFormatter.propTypes = {
  shipmentIds: PropTypes.array,
};

ShipmentsFormatter.defaultProps = {
  shipmentIds: [],
};

export default ShipmentsFormatter;
